import { ModuleConfig } from './types';
import { Submissions } from '@prometheus/submissions';
import { CdmDataSources } from '@prometheus/cdm-data-sources';
import { Documents } from '@prometheus/documents';
import { Admin } from './modules';
import i18n from 'i18next';

export const modulesSideNavigation = (t): ModuleConfig[] => [
  {
    title: i18n.t('main_menu.submissions'),
    name: 'submissions',
    path: 'submissions',
    iconName: 'library',
    subModules: {
      documents: Documents,
      dataSources: CdmDataSources,
    },
    isMainMenu: true,
    component: Submissions,
  },
  {
    title: i18n.t('main_menu.admin'),
    name: 'admin',
    path: 'admin',
    iconName: 'admin',
    subModules: {
      documents: Documents,
    },
    isMainMenu: true,
    component: Admin,
  },
];
